const galleryStartPositon =
  document.querySelector('.variant-container input:checked').getAttribute('data-media-position') - 1;

const gallerySlider = new Splide('#main-slider', {
  start: galleryStartPositon,
  type: 'fade',
  pagination: false,
  arrows: true,
  cover: true,
});

const gallerySliderThumbnails = new Splide('#thumbnail-slider', {
  start: galleryStartPositon,
  rewind: true,
  fixedWidth: 36,
  fixedHeight: 45,
  isNavigation: true,
  gap: 10,
  focus: 'center',
  pagination: false,
  focus: 0,
  arrows: false,
  cover: true,
  trimSpace: 'move',
  dragMinThreshold: {
    mouse: 4,
    touch: 10,
  },
});

gallerySlider.sync(gallerySliderThumbnails);
gallerySlider.mount();
gallerySliderThumbnails.mount();

const progressNumbers = document.querySelector('[data-progress-number]');

progressNumbers.textContent = `${galleryStartPositon + 1}/${gallerySlider.length}`;

gallerySlider.on('moved', (newIndex) => {
  progressNumbers.textContent = `${newIndex + 1}/${gallerySlider.length}`;
  const video = gallerySlider.Components.Elements.slides[newIndex].querySelector('video');
  if (video) {
    video.play();
  }
});

const galleryVideo = gallerySlider.Components.Elements.slides[galleryStartPositon].querySelector('video');
if (galleryVideo) {
  galleryVideo.play();
}
